// Generated by ReScript, PLEASE EDIT WITH CARE


var cardNoInputTestId = "cardNoInput";

var expiryInputTestId = "expiryInput";

var cardCVVInputTestId = "cvvInput";

var cardHolderNameInputTestId = "BillingName";

var fullNameInputTestId = "FullName";

var emailInputTestId = "email";

var addressLine1InputTestId = "line1";

var cityInputTestId = "city";

var countryDropDownTestId = "Country";

var stateDropDownTestId = "State";

var postalCodeInputTestId = "postal";

var fieldTestIdMapping = {
  "billing.address.city": cityInputTestId,
  "billing.address.country": countryDropDownTestId,
  "billing.address.first_name": cardHolderNameInputTestId,
  "billing.address.last_name": cardHolderNameInputTestId,
  "billing.address.line1": addressLine1InputTestId,
  "billing.address.state": stateDropDownTestId,
  "billing.address.zip": postalCodeInputTestId,
  email: emailInputTestId,
  "payment_method_data.card.card_cvc": cardCVVInputTestId,
  "payment_method_data.card.card_exp_month": expiryInputTestId,
  "payment_method_data.card.card_exp_year": expiryInputTestId,
  "payment_method_data.card.card_holder_name": fullNameInputTestId,
  "payment_method_data.card.card_number": cardNoInputTestId
};

var paymentMethodListTestId = "paymentList";

var paymentMethodDropDownTestId = "paymentMethodsSelect";

var addNewCardIcon = "addNewCard";

var datePickerPlaceHolderText = "Enter Date of Birth";

export {
  paymentMethodListTestId ,
  paymentMethodDropDownTestId ,
  cardNoInputTestId ,
  expiryInputTestId ,
  cardCVVInputTestId ,
  cardHolderNameInputTestId ,
  fullNameInputTestId ,
  emailInputTestId ,
  addressLine1InputTestId ,
  cityInputTestId ,
  countryDropDownTestId ,
  stateDropDownTestId ,
  postalCodeInputTestId ,
  addNewCardIcon ,
  datePickerPlaceHolderText ,
  fieldTestIdMapping ,
}
/* No side effect */
